import React from 'react';
import styled from 'styled-components';

const Box = styled.div`
  background-color: rgba(0, 0, 0, 0.18);
  display: block;
  height: 1px;
  width: 100%;
  margin-bottom: 24px;
`;

const Hr = props => <Box />;

export default Hr;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/subComponents/Hr.jsx